import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/**
 * @implements {IChilduppNotification}
 */
export class PhonegapChilduppNotification {

    constructor() {
        Object.defineProperties(this, {
            /**
             * @private
             * @property {PushPlugin} #_push
             */
            _push: {
                value: buildPhonegapPlugin(),
            },
            /**
             * @private
             * @type {BehaviorSubject<boolean|undefined>}
             */
            _hasPermission$: {
                // When running in cordova, notification permissions are
                // granted on installation
                value: new BehaviorSubject(true),
            },
            /**
             * @private
             * @property {BehaviorSubject<string|null|undefined>} #_token$
             */
            _token$: { value: new BehaviorSubject(undefined) },
            /**
             * @private
             * @property {BehaviorSubject<IChilduppNotification~Notification>} #_notifications$
             */
            _notifications$: {
                value: new Subject()
                    // remove repeated push notifications
                    // when the app is in background
                    // and click in the push notification center
                    .distinct(function(data) {
                        return JSON.stringify(data);
                    })
            },
        });
        // Bind observables once fcm is ready
        this._push.then((push) => {

            push.on('registration', (data) => {
                if (data.registrationId !== this._token$.getValue()) {
                    this._token$.next(data.registrationId);
                }
            });


            // Pipe fcm notifications to our Subject
            push.on('notification',
                (notification) => {
                    console.log(notification);
                    var timestamp = Date.now();
                    if (notification.additionalData && notification.additionalData.timestamp) {
                        timestamp = notification.additionalData.timestamp;
                    }
                    this._notifications$.next({
                        title: notification.title,
                        body: notification.message,
                        icon: notification.image,
                        timestamp: timestamp
                    });
                }
            );

            push.on('error', (error) => console.error('Error while registering FirebasePlugin.onNotificationOpen', error))

        });
        // If fcm initialization fails for whatever reason, emit some significative values
        this._push.catch((e) => {
            console.error('Couldn\'t initialzie push due to', e);
            this._hasPermission$.next(false);
            this._token$.next(null);
        });
    }

    /**
     * @inheritDoc
     */
    name() {
        return "PhonegapNotification@" +
            window.cordova.require("cordova/plugin_list").metadata["phonegap-plugin-push"]
    }

    /**
     * @inheritDoc
     */
    async requestPermission() {
        // When running in cordova, notification permissions are
        // granted on installation
        return Promise.resolve();
    }

    /**
     * @inheritDoc
     */
    hasPermission() {
        return this._hasPermission$.getValue();
    }

    /**
     * @inheritDoc
     */
    getToken() {
        return this._token$.getValue();
    }

    /**
     * @inheritDoc
     */
    onTokenRefresh(cb) {
        const subscription = this._token$.subscribe((token) => {
            cb(token)
        });
        return () => {
            subscription.unsubscribe();
        };
    }

    /**
     * @inheritDoc
     */
    onNotification(cb) {
        const subscription = this._notifications$.subscribe((notification) => {
            cb(notification)
        });
        return () => {
            subscription.unsubscribe();
        };
    }
}

/**
 * Prepares the firebase cloud messaging layer based on cordova-firebase-plugin. If
 * initialization fails the promise will be rejected.
 *
 * @return {PushNotification}
 * @see https://github.com/phonegap/phonegap-plugin-push
 * @see https://github.com/phonegap/phonegap-plugin-push/blob/master/docs/API.md
 */
function buildPhonegapPlugin() {

    if (!window.PushNotification) {
        const err = new Error('window.PushNotification is not available. Check \'deviceready\' event has been fired');
        return Promise.reject(err);
    }

    const push = window.PushNotification.init({
        android: {
            icon: "icon",
            iconColor: "grey"
        },
        ios: {
            alert: "true",
            badge: "true",
            sound: "true"
        },
        windows: {}
    });

    return Promise.resolve(push);
}



// WEBPACK FOOTER //
// ./src/shared/childupp-notifications/phonegap-childupp-notification.js